<div class="min-h-screen flex items-center justify-center bg-base-200">
  <div class="daisy-card w-96 bg-base-100 shadow-xl">
    <div class="daisy-card-body items-center text-center">
      <h1 class="text-8xl font-bold text-error">404</h1>
      <h2 class="daisy-card-title text-2xl mt-4">Page Not Found</h2>
      <p class="text-base-content/70">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
      <div class="daisy-card-actions mt-6">
        <a routerLink="/" class="daisy-btn daisy-btn-primary">Go to Homepage</a>
      </div>
    </div>
  </div>
</div> 